import { render, staticRenderFns } from "./MahkemeSecim.vue?vue&type=template&id=2d6c9754"
import script from "./MahkemeSecim.vue?vue&type=script&lang=ts"
export * from "./MahkemeSecim.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports